import styled from "@emotion/styled";
import { getErrorClientInfo } from "./getErrorClientInfo";

const RootDiv = styled.div([
    {
        display: "flex",
        flexWrap: "wrap",
        gap: 12,
        justifyContent: "center",
    }
]);

const ItemDiv = styled.div([
    {
        display: "flex",
        flexWrap: "nowrap",
    }
]);

interface ErrorAdditionalInfoProps {

}

const ErrorAdditionalInfo: React.FC<ErrorAdditionalInfoProps> = () => {

    const errorClientInfo = getErrorClientInfo();

    return (
        <RootDiv>
            {errorClientInfo.map((item, index) => (
                <ItemDiv key={index}>
                    {item}
                </ItemDiv>
            ))}
        </RootDiv>
    );
}

export default ErrorAdditionalInfo;